/* eslint-disable import/prefer-default-export */

export const unsubscribeFromPushManager = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((reg) => reg.pushManager.getSubscription())
      .then((subs) => {
        if (subs?.unsubscribe) {
          subs.unsubscribe();
        }
      });
  }
};
